import {loadColors} from "./utils";
import pie from "./pie";
window.runPie = function(resourceUrl,options) {
    const colorsRq = loadColors('colors.ddxml');
    const pieRq = fetch(resourceUrl+'cc_seats.jsonv').then(resp => resp.json());
    Promise.all([colorsRq,pieRq]).then(([colors, pieData])=>{
        pie('#calc',colors,pieData,options);
    }).catch(_=> $('#calc').remove());
}
